import { fromTable } from "../utils/tables";
import { looks } from "../tables";

export const getLooks = ({ formatMessage }) => {
  const result = fromTable(looks);
  const values = result.getValues ? result.getValues() : {};
  return formatMessage(result.name, values);
};
